function HeroSection() {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-badge">
          <span className="status-dot"></span>
          <span>Available for select collaborations</span>
        </div>

        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Hello, I'm Shavon, <span className="text-primary italic">AI engineer</span> with a taste for all things new and challenging.
            </h1>

            <p className="hero-intro">
              I build intelligent systems that solve real human constraints, inspired by the structure of code, a flawless itinerary, and  perfectly baked croissant.
            </p>

            <div className="hero-cta">
              <a href="#work" className="btn btn-primary" aria-label="View my work and projects">View Selected Work</a>
              <a href="#connect" className="btn" aria-label="Get in touch with me">Get in Touch</a>
            </div>
          </div>

          <div className="hero-cards">
            <div className="hero-blob-1"></div>
            <div className="hero-blob-2"></div>
            <div className="hero-cards-grid">
              <div className="cards-col">
                <div className="hero-card square">
                  <span className="hero-card-icon" role="img" aria-label="airplane">&#9992;</span>
                  <span className="hero-card-label">Currently Traveling</span>
                  <span className="hero-card-title">Pacific Northwest</span>
                </div>
                <div className="hero-card tall peach">
                  <span className="hero-card-icon" role="img" aria-label="food">&#127869;</span>
                  <span className="hero-card-label">Latest Obsession</span>
                  <span className="hero-card-title">Truffle Tagliatelle</span>
                </div>
              </div>
              <div className="cards-col">
                <div className="hero-card tall sage">
                  <span className="hero-card-icon" role="img" aria-label="brain">&#129504;</span>
                  <span className="hero-card-label">Currently Coding</span>
                  <span className="hero-card-title">LLM Agents</span>
                </div>
                <div className="hero-card square">
                  <span className="hero-card-icon" role="img" aria-label="coffee">&#9749;</span>
                  <span className="hero-card-label">Currently Enjoying</span>
                  <span className="hero-card-title">Jamaican Blue Mountain Coffee</span>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
